import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';
import { PersonalDataStateService } from 'src/app/_modules/customers/components/personal-data/services/personal-data-state.service';

@Component({
  selector: 'app-service-request-tracker-details',
  templateUrl: './service-request-tracker-details.component.html',
  styleUrls: ['./service-request-tracker-details.component.scss']
})
export class ServiceRequestTrackerDetailsComponent implements OnInit {

  serviceRequestTrackerDetails: any;
  selectedImage: string = '';
  currentRotation: number = 0;
  placeholderImage: string = '../../../../assets/no-image.png';
  imgZoomFullContainer: any;
  imgElement: any;
  totalLoad?: number = 0;
  clientType: string = '';
  customerType: string = '';
  isGeolocationMapVisible: boolean = false;
  selectedMapLatitude: number | null = null;
  selectedMapLongitude: number | null = null;
  areLocationImagesVisible: boolean = true;
  installationStatus: string = '';

  constructor(
    private accountKycService: AccountKycService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private stateService: PersonalDataStateService,
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('detailsId');
    this.getDetails(Number(id));
    this.setFieldsVisibility();
  }

  getDetails(id: number) {
    this.accountKycService.getServiceRequestTrackerDetails(id).subscribe(
      (response) => {
        this.serviceRequestTrackerDetails = response.data;
        this.installationStatus = this.serviceRequestTrackerDetails?.installation?.installationStatus ?? '';
        this.totalLoad = this.serviceRequestTrackerDetails?.accountKyc?.loadRequirements?.reduce(
          (sum: number, lr: any) => sum + (lr.wattage ?? 0), 0
        );
        this.setClientAndCustomerType();
      },
      (error) => {
        console.error('Error fetching service request tracker details:', error);
      }
    );
  }

  setClientAndCustomerType() {
    this.clientType = this.stateService.setClientType(this.serviceRequestTrackerDetails?.accountKyc?.clientType) ?? '';
    this.customerType = this.stateService.setCustomerType(this.serviceRequestTrackerDetails?.accountKyc?.customerType) ?? '';
  }

  setFieldsVisibility() {
    let notVisibleFields: any = localStorage.getItem('notVisibleFields');
    if (!notVisibleFields) {
      return;
    }
    notVisibleFields = JSON.parse(notVisibleFields);
    this.areLocationImagesVisible = notVisibleFields.find(
      (el: any) => el === 'locationPictures'
    )
      ? false
      : true;
  }

  showImage(num: number) {
    const accountKyc = this.serviceRequestTrackerDetails?.accountKyc;
    if (num === 0) {
      this.selectedImage = this.getFrontViewImage(0) || '';
    } else if (num === 1) {
      this.selectedImage = this.getFrontViewImage(1) || '';
    } else if (num === 2) {
      this.selectedImage = this.getFrontViewImage(2) || '';
    } else if (num === 3) {
      this.selectedImage = this.getBuildingMountedImage() || '';
    } else if (num === 4) {
      this.selectedImage = this.getCardImage() || '';
    } else if (num === 5) {
      this.selectedImage = accountKyc?.customersSignitureUrl;
    } else if (num === 6) {
      this.selectedImage = accountKyc?.landlordsSignitureUrl;
    } else if (num === 7) {
      this.selectedImage = accountKyc?.electricalContractorsSignitureUrl;
    } else if (num === 8) {
      this.selectedImage = accountKyc?.applicantsSignitureUrl;
    } else if (num === 9) {
      this.selectedImage = accountKyc?.passportUrl;
    } else if (num === 10) {
      this.selectedImage = this.getCutOutImage() || '';
    } else if (num === 11) {
      this.selectedImage = this.getUtilitySupplyImage() || '';
    }
  }

  getBuildingMountedImage() {
    return this.serviceRequestTrackerDetails?.siteVerification?.images?.find(
      (x: any) => x.imageType === 'MountedTag'
    )?.url;
  }
  getCardImage() {
    return this.serviceRequestTrackerDetails?.siteVerification?.images?.find(
      (x: any) => x.imageType === 'Card'
    )?.url;
  }
  getUtilitySupplyImage() {
    return this.serviceRequestTrackerDetails?.siteVerification?.images?.find(
      (x: any) => x.imageType === 'UtilitySupply'
    )?.url;
  }
  getCutOutImage() {
    return this.serviceRequestTrackerDetails?.siteVerification?.images?.find(
      (x: any) => x.imageType === 'CutOutFuse'
    )?.url;
  }
  getFrontViewImage(id: number) {
    return this.serviceRequestTrackerDetails?.siteVerification?.images?.filter(
      (x: any) => x.imageType === 'Frontview'
    )[id]?.url;
  }

  rotateRight() {
    this.currentRotation += 90;
  }
  rotateLeft() {
    this.currentRotation -= 90;
  }

  onModalFade() {
    this.currentRotation = 0;
    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;
      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
    this.selectedImage = '';
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  openGeolocationMap(latitude?: number | null, longitude?: number | null) {
    if (latitude == null || longitude == null) {
      return;
    }
    this.selectedMapLatitude = latitude;
    this.selectedMapLongitude = longitude;
  }

  onGeolocationMapModalOpen() {
    this.isGeolocationMapVisible = true;
  }

  onGeolocationMapModalFade() {
    this.isGeolocationMapVisible = false;
    this.selectedMapLatitude = null;
    this.selectedMapLongitude = null;
  }

  subServieSpaces(value: string | undefined) {
    switch (value) {
      case 'PublicLoad':
        return 'Public Load';
      case 'MeterReplacement':
        return 'Meter Replacement';
      case 'Migration':
        return 'Migration';
      case 'Separation':
        return 'Separation';
      case 'PointLoadTransformer':
        return 'Point Load Transformer';
      case 'DedicatedFeeder':
        return 'Dedicated Feeder';
      default:
        return value;
    }
  }

  openPdf(pdfUrl: string) {
    if (pdfUrl == '') {
      this.toastr.info('No PDF to view.');
      return;
    }
    window.open(pdfUrl, '_blank');
  }

  downloadPDF() {
    const url = this.serviceRequestTrackerDetails?.installation?.installationFormUrl;

    if (!url || url.trim() === '') {
      this.toastr.warning('This installation does not have a form to download');
      return;
    }

    const a = document.createElement('a');
    a.href = url;
    a.download = url.split('/').pop()?.split('?')[0] || 'document.pdf';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
